export default __webpack_public_path__ + "static/media/thermo.fb95c668.svg";